import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-2 pl-4" }

import { computed } from "vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'TextAreaRow',
  props: {
    modelValue: {},
    title: {},
    errors: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "text-form pl-4 pr-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "3" }, {
        default: _withCtx(() => [
          _createElementVNode("h6", _hoisted_1, _toDisplayString(__props.title), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "9" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_textarea, {
            class: "small pt-2",
            modelValue: modelValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
            rows: "3",
            errorMessages: props.errors
          }, null, 8, ["modelValue", "errorMessages"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})